import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModalComponent } from '@common2/components/modal/modal.component';
import { CommonToastService } from '@common2/services/toast.service';
import { CompanyCertificatesProvider, CompanyExperience } from '@lighty';
import { StorageService, TranslateService } from '@services';
import { CookieService } from 'ngx-cookie-service';
import { take } from 'rxjs';
import { CommonSelectDatum } from '@common2/components/select/select.component';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-certificates',
    templateUrl: './certificates.component.html',
    styleUrls: ['./certificates.component.scss'],
})
export class WatchCertificatesComponent implements OnInit {
    @ViewChild('modalAdd') modalAdd: CommonModalComponent;
    @ViewChild('modalDelete') modalDelete: CommonModalComponent;

    public experience: CompanyExperience;

    public emitedCertificates: any;
    public emitedTemplates: any;
    public emitedCreateTemplate: any;

    public templateItemDescription: string = '';
    public templateItemGroup: string = '';
    public templateItemTemplate: string = '';
    public templateItemCatalogue: string = '';
    public templateItemMinimumProgress: number;

    public availableTypes: any;
    public groups = [];
    public exportGroup: any;

    public checkInputs: boolean = false;

    public modalTitle: string = '';
    public newItemId: string = '';
    public newItemName: string = '';
    public newItemLabel: string = '';
    public selectedItemId: string = '';
    public newList: Array<any> = [];
    public newListDisplayed: Array<any> = [];
    public tableContent: any;
    public isLoading: boolean = true;
    public isLoadingTable: boolean = true;
    public hasError: boolean = false;
    public errorMsg: string = '';
    public currentDashboardId: string = '';
    public isEdit: boolean = false;
    public filters: any;
    public selectSelections: any = {
        template: {
            id: '',
            name: '',
        },
        group: {
            id: '',
            name: '',
        },
        catalog: [],
    };
    public selectedItem: Array<any> = [];
    public showDate: boolean = false;
    public initialCertificateDate: any = '';
    public currentEditTemplateId: any = -1;
    public currentDeleteTemplateId: number = -1;
    public currentExperienceId: string = '';
    public currentEditItem: any;

    // POK vs Xertify detection
    public isPok: boolean = false;
    public isXertify: boolean = false;

    // Campos personalizados que declara la plantilla POK elegida. Reemplazan al input de texto
    // libre: antes el nombre del campo se escribia a mano y un typo no daba error al guardar,
    // hacia fallar la emision entera despues, cuando POK la rechazaba con "unexpected params".
    public pokTemplateFields: Array<any> = [];
    // false = no se pudo consultar a POK. En ese caso se vuelve al input libre en vez de bloquear
    // la configuracion: impedir configurar por una caida del proveedor es peor que permitir un
    // typo, que ademas la validacion del backend vuelve a atrapar al guardar.
    public pokFieldsAvailable: boolean = false;
    public isLoadingPokFields: boolean = false;
    public company: any;

    constructor(
        private companyCertificatesProvider: CompanyCertificatesProvider,
        private storageService: StorageService,
        private cookieService: CookieService,
        private toastService: CommonToastService,
        private translateService: TranslateService,
    ) {
        this.company = this.storageService.get('company');
        this.detectProvider();
    }

    ngOnInit(): void {
        this.getTemplates();
    }

    private detectProvider(): void {
        if (this.company?.permissions) {
            this.isPok = this.company.permissions.companyProviderPok === true;
            this.isXertify = this.company.permissions.companyProviderXertify === true;
        }
       
    }

    public openModalAdd(): void {
        this.clearAllData();
        this.modalTitle = 'create';
        this.isEdit = false;
        console.log(this.selectSelections)
        this.modalAdd.onOpen();
        console.log(this.emitedTemplates.catalogs)
    }

    public getTemplates(): void {
        this.isLoadingTable = true;
        const params = {
            experienceId: this.getExperienceIdFromCurrentUrl()
        };

        // Use POK or Xertify endpoint based on provider
        const request$ = this.isPok
            ? this.companyCertificatesProvider.getPokTemplates(this.cookieService.get('current_company'), { experience_id: params.experienceId })
            : this.companyCertificatesProvider.getTemplates(this.cookieService.get('current_company'), params);

        request$
            .pipe(take(1))
            .subscribe(
                (data) => {
                    console.log(data);
                    this.emitedTemplates = data.data;
                    
                    // Map POK response to match expected structure
                    if (this.isPok && this.emitedTemplates) {
                        this.emitedTemplates.pTemplates = this.emitedTemplates.pTemplates || this.emitedTemplates.p_templates || [];
                        this.emitedTemplates.localFields = this.emitedTemplates.localFields || this.emitedTemplates.local_fields || [];
                    }
                    
                    console.log(this.emitedTemplates);
                    this.isLoadingTable = false;
                    this.isLoading = false;
                },
                (err) => {
                    console.log(err);
                  
                    // END TODO: REMOVE
                    this.hasError = true;
                    this.isLoadingTable = false;
                    this.isLoading = false;
                    this.errorMsg = err.error.error;
                }
            );
    }

    public resetFields(): void {
        this.newItemId = '';
        this.newItemName = '';
        this.newItemLabel = '';
        this.selectedItemId = '';
    }

    public openEdit(data: any): void {
        console.log(data);
        this.clearAllData();
        
        if (this.isPok) {
            // POK structure - API returns camelCase
            const templateItem = {
                name: data.pTemplateName,
                id: data.pTemplateId
            };
            const catalogItem = JSON.parse(data.providerIds || '[]');

            this.isEdit = true;
            this.isLoading = false;
            this.modalTitle = 'edit';
            this.templateItemDescription = data.description;
            this.selectSelections.template.id = data.pTemplateId;
            this.selectSelections.template.name = data.pTemplateName;
            this.templateItemMinimumProgress = data.minScore;
            this.initialCertificateDate = data.startCertificateAt;
            this.currentEditTemplateId = data.id;
            this.currentExperienceId = data.experienceId;
            this.currentEditItem = data;

            this.onSelectType(templateItem, 'template');

            if (data.dynamicData && Array.isArray(data.dynamicData)) {
                data.dynamicData.forEach(element => {
                    this.addNewItemToNewListPok(element);
                });
            }

            const catalogIds = JSON.parse(data.providerIds || '[]');
            catalogIds.forEach(catalogId => {
                const catalogIndex = this.emitedTemplates.catalogs?.findIndex(item => item.id === catalogId);
                if (catalogIndex !== undefined && catalogIndex !== -1) {
                    const item = {
                        id: catalogId,
                        name: this.emitedTemplates.catalogs[catalogIndex].name,
                        isSelect: false,
                        isSelected: true,
                    };
                    this.emitedTemplates.catalogs.splice(catalogIndex, 1);
                    this.emitedTemplates.catalogs.push(item);
                    this.onSet(true, item);
                }
            });
        } else {
            // Xertify structure (original)
            const templateItem = {
                name: data.xTemplateName,
                id: data.xTemplateId
            };
            const groupItem = {
                name: data.xGroupName,
                id: data.xGroupId
            };
            const catalogItem = JSON.parse(data.providerIds || '[]');

            this.isEdit = true;
            this.isLoading = false;
            this.modalTitle = 'edit';
            this.templateItemDescription = data.description;
            this.selectSelections.group.id = data.xGroupId;
            this.selectSelections.template.id = data.xTemplateId;
            this.templateItemMinimumProgress = data.minScore;
            this.initialCertificateDate = data.startCertificateAt;
            this.currentEditTemplateId = data.id;
            this.currentExperienceId = data.experienceId;
            this.currentEditItem = data;

            this.onSelectType(templateItem, 'template');
            this.onSelectType(groupItem, 'group');
            if (data.dynamicData && Array.isArray(data.dynamicData)) {
                data.dynamicData.forEach(element => {
                    this.addNewItemToNewList(element);
                });
            }
            catalogItem.forEach(catalogId => {
                const catalogIndex = this.emitedTemplates.catalogs?.findIndex(item => item.id === catalogId);
                if (catalogIndex !== undefined && catalogIndex !== -1) {
                    const item = {
                        id: catalogId,
                        name: this.emitedTemplates.catalogs[catalogIndex].name,
                        isSelect: false,
                        isSelected: true,
                    };
                    this.emitedTemplates.catalogs.splice(catalogIndex, 1);
                    this.emitedTemplates.catalogs.push(item);
                    this.onSet(true, item);
                }
            });
        }

        this.modalAdd.onOpen();
    }

    formatData(dateFormat: any): string {
        if (!dateFormat) return '';
        const date = new Date(dateFormat);
        if (isNaN(date.getTime())) return '';

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    public createTemplate(): void {
        let request$;

        if (this.isPok) {
            // POK payload structure
            const pokData = {
                company_id: this.cookieService.get('current_company'),
                experience_id: Number(this.getExperienceIdFromCurrentUrl()),
                p_template_id: this.selectSelections.template.id,
                provider_ids: this.selectedItem.map((item) => item.id),
                description: this.templateItemDescription,
                min_score: Number(this.templateItemMinimumProgress),
                start_certificate_at: this.initialCertificateDate,
                dynamic_data: this.newList.map(item => ({
                    p_field: item.p_field || item.x_field,
                    local_field: item.local_field,
                    local_value: item.local_value
                }))
            };
            request$ = this.companyCertificatesProvider.createPokTemplate(pokData);
        } else {
            // Xertify payload structure
            const xertifyData = {
                description: this.templateItemDescription,
                x_group_id: this.selectSelections.group.id,
                x_template_id: this.selectSelections.template.id,
                experience_id: this.getExperienceIdFromCurrentUrl(),
                provider_ids: this.selectedItem.map((item) => item.id),
                dynamic_data: this.newList,
                min_score: Number(this.templateItemMinimumProgress),
                start_certificate_at: this.initialCertificateDate,
            };
            request$ = this.companyCertificatesProvider.setTemplates(xertifyData);
        }

        request$
            .pipe(take(1))
            .subscribe((data) => {
                this.toastService.onSuccess(
                    this.translateService.instant(data.message)
                );
                this.clearAllData();
                this.modalAdd.onClose();
                this.getTemplates();
            },(error) => {
                console.log(error.error.message)
                this.toastService.onError(
                    this.translateService.instant(error.error.message)
                )
            });
    }

    public onInputChange(): void {
        const baseValidation = 
            this.templateItemDescription != '' &&
            this.selectSelections.template.id != '' &&
            this.newList.length != 0 &&
            Number(this.templateItemMinimumProgress) > -1 &&
            Number(this.templateItemMinimumProgress) < 101 &&
            this.selectedItem.length > 0 &&
            this.initialCertificateDate != '';

        if (this.isPok) {
            // POK doesn't require group
            this.checkInputs = baseValidation;
        } else {
            // Xertify requires group
            this.checkInputs = baseValidation && this.selectSelections.group.id != '';
        }
    }

    getIterativeCheck(parent: any, selected: any) {
        if (parent.children && parent.children.length) {
            parent.children = parent.children.map((child: any) => {
                if (parent.id === selected.id) {
                    child.isSelected = parent.isSelected;
                }
                return child;
            });
            return parent;
        } else {
            return parent;
        }
    }

    onSelectType(option, origin) {
        if (origin != 'localField') {
            this.selectSelections[origin] = option;
        } else {
            this.newItemId = option.value;
            this.newItemLabel = this.translateService.instant(option.name);
            this.selectedItemId = this.translateService.instant(option.name);
        }

        // Al cambiar de plantilla, los campos disponibles cambian: se recargan y se limpia el
        // campo elegido, que puede no existir en la plantilla nueva.
        if (origin === 'template' && this.isPok) {
            this.newItemName = '';
            this.loadPokTemplateFields(option?.id);
        }

        this.onInputChange();
    }

    /**
     * Trae los campos personalizados que declara la plantilla POK elegida.
     */
    private loadPokTemplateFields(pTemplateId: string): void {
        this.pokTemplateFields = [];
        this.pokFieldsAvailable = false;

        if (!pTemplateId) {
            return;
        }

        this.isLoadingPokFields = true;

        this.companyCertificatesProvider
            .getPokTemplateFields(this.cookieService.get('current_company'), pTemplateId)
            .subscribe({
                next: (data: any) => {
                    this.isLoadingPokFields = false;
                    this.pokFieldsAvailable = !!data?.available;
                    this.pokTemplateFields = data?.fields ?? [];
                },
                error: () => {
                    // Se cae al input de texto libre a proposito, ver el comentario de
                    // pokFieldsAvailable.
                    this.isLoadingPokFields = false;
                    this.pokFieldsAvailable = false;
                    this.pokTemplateFields = [];
                },
            });
    }

    /**
     * Selecciona un campo de la plantilla desde el desplegable.
     */
    public onSelectPokField(field: any): void {
        this.newItemName = field?.value ?? '';
        this.onInputChange();
    }

    /**
     * Un campo ya configurado que la plantilla actual NO declara.
     *
     * Pasa cuando la plantilla se edita del lado de POK despues de haberse configurado: la fila
     * guardada queda apuntando al vacio. Se marca en la tabla en vez de ocultarla, para que el
     * administrador vea exactamente que tiene roto.
     */
    public isUnknownPokField(pField: string): boolean {
        if (!this.isPok || !this.pokFieldsAvailable || !pField) {
            return false;
        }

        return !this.pokTemplateFields.some((f: any) => f.value === pField);
    }

    onSelectGropu(datum: CommonSelectDatum<string>) {
        this.groups = this.groups.map((d) => {
            d.isSelected = d.id === datum.id;
            return d;
        });
        this.exportGroup = datum.value;
    }

    public getSelectedDisplayValues(filterKey: string): any {
        const filter = this.filters[filterKey];
        if (filterKey === 'languages') {
            if (!filter || !Array.isArray(filter)) {
                return [];
            }

            return filter
                .filter((item: any) => item.isSelected)
                .map((item: any) => item.value);
        } else {
            if (!filter || !Array.isArray(filter)) {
                return '';
            }

            const selectedValues = filter
                .filter((item: any) => item.isSelected)
                .map((item: any) => item.value);

            return selectedValues.join(', ');
        }
    }

    public addNewItemToNewList(editItem?: any): void {
        const item = {
            x_field: editItem ? editItem.xField : this.newItemName,
            local_field: editItem ? editItem.localField : this.newItemId,
            local_value: editItem ? editItem.localValue : this.newItemLabel,
            id: editItem ? editItem.id : '',
        };
        const displayItem = {
            xertifyField: editItem ? editItem.xField : this.newItemName,
            localField: editItem ? this.translateService.instant((`words.${editItem.localField}`).replace(/_/g, '-')) : this.selectedItemId,
            valueField: this.translateService.instant((`words.${editItem?.localValue}`).replace(/_/g, '-')) ? this.translateService.instant((`words.${editItem?.localValue}`).replace(/_/g, '-')) : editItem?.localValue,
        }
        this.newListDisplayed.push(displayItem);
        this.newList.push(item);
        this.resetFields();
        this.onInputChange();
    }

    public addNewItemToNewListPok(editItem?: any): void {
        // API returns camelCase (pField, localField, localValue), internal list uses snake_case
        const pField = editItem ? (editItem.pField ?? editItem.p_field ?? this.newItemName) : this.newItemName;
        const localField = editItem ? (editItem.localField ?? editItem.local_field ?? this.newItemId) : this.newItemId;
        const localValue = editItem ? (editItem.localValue ?? editItem.local_value ?? this.newItemLabel) : this.newItemLabel;

        const item = {
            p_field: pField,
            local_field: localField,
            local_value: localValue,
            id: editItem ? editItem.id : undefined,
        };
        const displayItem = {
            xertifyField: pField,
            localField: editItem ? this.translateService.instant((`words.${localField}`).replace(/_/g, '-')) : this.selectedItemId,
            valueField: localValue ? (this.translateService.instant((`words.${localValue}`).replace(/_/g, '-')) || localValue) : '',
        };
        this.newListDisplayed.push(displayItem);
        this.newList.push(item);
        this.resetFields();
        this.onInputChange();
    }

    public removeItemFromNewList(index: number): void {
        this.newList.splice(index, 1);
        this.newListDisplayed.splice(index, 1);
        this.onInputChange();
    }

    public verifyNewInputs(): boolean {
        if (this.newItemId != '' && this.newItemName != '') {
            return false;
        } else {
            return true;
        }
    }

    public onSet(value: any, datum: any): void {
        const item = {
            id: datum.id,
            name: datum.name,
        };
        if (value) {
            if (!this.selectedItem.some(existingItem => existingItem.id === item.id)) {
                this.selectedItem.push(item);
            }
        } else {
            const index = this.selectedItem.findIndex(existingItem => existingItem.id === item.id);
            if (index !== -1) {
                this.selectedItem.splice(index, 1);
            }
        }
        console.log(this.emitedTemplates.catalogs)
        datum.isSelected = value;
        this.onInputChange();
    }
        

    public validateScale(e: any) {
        const value = parseInt(e.target.value);
        if (value < 0) {
            e.target.value = 0;
            this.onInputChange();
        } else if (value > 100) {
            e.target.value = 100;
            this.onInputChange();
        }
    }

    public updateTemplate(): void {
        let request$;

        if (this.isPok) {
            // POK payload structure
            const pokData = {
                company_id: this.cookieService.get('current_company'),
                experience_id: Number(this.currentExperienceId),
                p_template_id: this.selectSelections.template.id,
                provider_ids: this.selectedItem.map((item) => item.id),
                description: this.templateItemDescription,
                min_score: Number(this.templateItemMinimumProgress),
                start_certificate_at: this.initialCertificateDate,
                dynamic_data: this.newList.map(item => ({
                    ...(item.id ? { id: item.id } : {}),
                    p_field: item.p_field || item.x_field,
                    local_field: item.local_field,
                    local_value: item.local_value
                }))
            };
            console.log(pokData);
            request$ = this.companyCertificatesProvider.updatePokTemplate(pokData, this.currentEditTemplateId);
        } else {
            // Xertify payload structure
            const xertifyData = {
                description: this.templateItemDescription,
                x_group_id: this.selectSelections.group.id,
                x_template_id: this.selectSelections.template.id,
                experience_id: this.currentExperienceId,
                provider_ids: this.selectedItem.map((item) => item.id),
                dynamic_data: this.newList,
                min_score: Number(this.templateItemMinimumProgress),
                start_certificate_at: this.initialCertificateDate,
            };
            console.log(xertifyData);
            request$ = this.companyCertificatesProvider.updateTemplate(xertifyData, this.currentEditTemplateId);
        }

        request$
            .pipe(take(1))
            .subscribe((data) => {
                this.emitedCreateTemplate = data.data;
                this.toastService.onSuccess(
                    this.translateService.instant('toast.saved')
                );
                this.clearAllData();
                this.modalAdd.onClose();
                this.getTemplates();
                console.log(this.emitedCreateTemplate);
            },(error) => {
                console.log(error.error.message)
                this.toastService.onError(
                    this.translateService.instant(error.error.message)
                )
            });

    }

    public clearAllData(): void {
        this.newList = [];
        this.newListDisplayed = [];
        this.selectedItemId = '';
        this.templateItemDescription = '';
        this.selectSelections.group.id = '';
        this.selectSelections.template.id = '';
        this.selectSelections.group.name = '';
        this.selectSelections.template.name = '';
        this.selectSelections.catalog = [];
        this.templateItemMinimumProgress = undefined;
        this.initialCertificateDate = '';
        this.selectedItem = [];
        this.currentEditTemplateId = -1;
        this.isLoading = false;
        this.hasError = false;
        this.isEdit = false;
        this.emitedTemplates?.catalogs.forEach(element => {
            if('isSelected' in element) {
                element.isSelected = false;
            }
        });
        this.resetFields();
    }

    public deleteTemplate(): void {
        const request$ = this.isPok
            ? this.companyCertificatesProvider.deletePokTemplate(this.currentDeleteTemplateId)
            : this.companyCertificatesProvider.deleteTemplate(this.currentDeleteTemplateId);

        request$
        .pipe(take(1))
        .subscribe((data) => {
            this.toastService.onSuccess(
                this.translateService.instant(data.message)
            );
            this.currentDeleteTemplateId = -1;
            this.modalDelete.onClose();
            this.getTemplates();
        },(error) => {
            console.log(error.error.message)
            this.toastService.onError(
                this.translateService.instant(error.error.message)
            )
        });
    }

    public openModalDelete(templateId: number): void {
        console.log(templateId);
        this.currentDeleteTemplateId = templateId;
        this.modalDelete.onOpen();
    } 

    public toggleTemplateStatus(id: number): void {
        const request$ = this.isPok
            ? this.companyCertificatesProvider.togglePokTemplateStatus(id)
            : this.companyCertificatesProvider.toggleTemplateStatus(id);

        request$
        .pipe(take(1))
        .subscribe((data) => {
            console.log(data)
            this.getTemplates();
            this.toastService.onSuccess(
                this.translateService.instant(data.message)
            );
        },(error) => {
            console.log(error.error.message)
            this.toastService.onError(
                this.translateService.instant(error.error.message)
            )
        });
    }

    public getExperienceIdFromCurrentUrl(): string {
        const url = window.location.href;
        const regex = /\/experiences\/(\d+)\//;
        const match = url.match(regex);

        if (match && match[1]) {
            return match[1];
        } else {
            return null;
        }
    }
}
